import { FC, PropsWithChildren } from 'react';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatToolTipProps } from '../../types';

export const SystemAndComponentTooltip: FC<
  PropsWithChildren<CatToolTipProps>
> = ({ children, partsName, handleClick, ...tooltipProps }) => {
  return (
    <CatTooltip {...tooltipProps}>
      <CatHeading slot="trigger" variant="body-sm" onClick={handleClick}>
        <span className="text-truncate d-block m-0">{partsName}</span>
      </CatHeading>
      <CatHeading variant="body-sm">{children}</CatHeading>
    </CatTooltip>
  );
};
